// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1763050372355
      var cssReload = require("/var/www/chunsing-app-ui/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  